var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barL"},_vm._l((_vm.dataExponentList),function(i,index){return _c('div',{key:index,staticClass:"con"},[_c('div',{staticStyle:{"color":"#0358D2","font-size":"30px","font-weight":"600"}},[_vm._v(_vm._s(i.value))]),_c('div',{staticStyle:{"color":"#878786","font-size":"14px"}},[_vm._v(_vm._s(i.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }